import React, { useContext } from 'react';
import { defaultAudioContext } from './Audio.decl';
export var AudioContext = /*#__PURE__*/React.createContext(defaultAudioContext);
export var AudioTimeContext = /*#__PURE__*/React.createContext({
  currentTime: 0
});
export var useAudio = function useAudio() {
  return useContext(AudioContext);
};
export var useAudioTime = function useAudioTime() {
  return useContext(AudioTimeContext);
};